<template>
  <div class="must-read__wrapper">
    <p class="must-read__title">Must Read</p>
    <ul class="must-read__news-list">
      <li
        v-for="item in mustReadItems"
        :key="item.id"
        :class="getlistItemClass(item)"
      >
        <div class="must-read__link">
          <a-link
            :to="generateArticlePath(item.article)"
            :trailing-slash="!item.article.isMigrated"
            >{{ item.article.title }}</a-link
          >
        </div>
        <client-only>
          <div v-if="item.isSponsored" class="must-read__sponsored-label">
            Sponsored
          </div>
        </client-only>
      </li>
    </ul>
  </div>
</template>

<script>
import ALink from 'shared/ALink'
import mixins from '@/utils/mixins'
import { serverCacheKey } from '@/utils/mixins/serverCacheKey'
import { PROP_TYPES, propValidator } from '@fmpedia/validators'

export default {
  name: 'MustRead',
  mixins: [mixins.urlGenerators, serverCacheKey],
  components: { ALink },
  props: {
    mustReadItems: propValidator([PROP_TYPES.ARRAY])
  },
  methods: {
    getlistItemClass({ isHighlighted }) {
      return [
        'must-read__news-item',
        {
          'must-read__news-item--highlighted': isHighlighted
        }
      ]
    }
  },
  mounted() {
    this.$emit('mounted')
  }
}
</script>

<style lang="scss">
.must-read__wrapper {
  background: $c--gray-soft;
  padding: 24px;
  width: 100%;
  border-radius: 4px;

  .must-read__title {
    font-size: 22px;
    font-weight: 600;
    line-height: 28px;

    @include tablet {
      font-size: 20px;
    }
  }

  .must-read__news-list {
    margin-top: 10px;
  }

  .must-read__news-item {
    overflow: hidden;
    font-family: $font-body;
    font-size: 16px;
    font-weight: 300;
    line-height: 22px;
    border-bottom: 1px solid rgba($c--gray-2, 0.5);
    padding: 12px 12px 24px;

    &--highlighted {
      background: rgba($c--main, 0.16);
    }

    a {
      color: $c--gray-dark-2;
      display: inline-block;

      &:hover {
        color: $c--main;
      }
    }
  }

  .must-read__sponsored-label {
    margin-top: 12px;
    color: $c--gray-2;
    background: $c--white;
    font-size: 14px;
    line-height: 22px;
    display: inline-block;
    padding: 4px 10px;
    border-radius: 6px;
    border: 1px solid $c--gray-light;
  }
}
</style>
